import { formatNumber } from "utils/NumberUtils";

export const ProductTableRow = ({ product, sortedPortNames, getAssetName }) => {
  return (
    <tr key={`${product.asset}-${product.id}`}>
      <td style={{ textAlign: "left" }}>
        <div style={{ display: "flex" }}>
          <div>{getAssetName(product.asset)}</div>
          <div style={{ width: 0, height: 19.0 }}></div>
        </div>
      </td>
      <td
        style={{
          textAlign: "left",
          minWidth: 350,
          maxWidth: 398,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {/* 運用プロダクト */}
        {/* プロダクト名が25文字を超える場合は25文字+ ... と表示 */}
        {product.name.length > 25
          ? product.name.slice(0, 25) + "..."
          : product.name}
      </td>
      <td>
        {formatNumber({
          v: product.return,
          numDigits: 2,
          postfix: "%",
          stringForNonNumber: "N/A",
        })}
      </td>
      <td>
        {formatNumber({
          v: product.risk,
          numDigits: 2,
          postfix: "%",
          stringForNonNumber: "N/A",
        })}
      </td>
      {sortedPortNames.map((port) => (
        <td key={`${product.asset}-${product.id}-${port}`}>
          {formatNumber({
            v: product[port]?.assignRate,
            n: 100,
            numDigits: 1,
            postfix: "%",
            stringForNonNumber: "-",
          })}
        </td>
      ))}
    </tr>
  );
};
